import React, { useMemo } from 'react';
import Table from '../components/Table/Table';
import useDishes from '../features/DishContainer/hooks/useDishes';
import Columns from '../features/DishContainer/columns';
import useExcludeDishes from '../features/DishContainer/hooks/useExcludeDishes';
import { toJS } from '../utils/immutableUtils';
import View from './views';
import PaperContainer from '../components/common/PaperContainer';
import ProgressFullscreen from '../components/common/ProgressFullscreen';

const NewDishesView = () => {
  const filter = useMemo(
    () => ({
      isGlobalBased: false,
      hasPpsi: false
    }),
    []
  );
  const status = 'NEW';
  const [isFetching, dishesRaw] = useDishes(filter, status);
  const dishes = toJS(dishesRaw, []);
  const [excludeDishes] = useExcludeDishes();
  View.NewDishesView.visit();

  if (isFetching) {
    return <ProgressFullscreen open />;
  }

  function clickExcludeDishes(selectedData, callback) {
    const formulaCodes = selectedData.map(row => row.data.formulaCode);
    excludeDishes(formulaCodes);
    callback();
  }

  return (
    <PaperContainer>
      <Table
        title="dish.newDishesTitle"
        data={dishes}
        columns={[
          Columns.IfoodID,
          Columns.PresentationName,
          Columns.PiaNumber,
          Columns.LifeCycleStatus,
          Columns.ModifyDate,
          Columns.CreateAndCopyPpsi
        ]}
        getObjectId={object => object.id}
        defaultSorting={[{ columnName: 'presentationName', direction: 'asc' }]}
        selectable
        showLanguageSelector={false}
        actions={[{ label: 'Exclude', onClick: clickExcludeDishes }]}
      />
    </PaperContainer>
  );
};

export default NewDishesView;
